import { render, staticRenderFns } from "./CashSettlementsOverview.vue?vue&type=template&id=22127cb8&"
import script from "./CashSettlementsOverview.vue?vue&type=script&lang=js&"
export * from "./CashSettlementsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports